import { InlineSelect } from './InlineSelect'
import {
  TASK_STATUS_LABELS,
  type TaskStatus,
} from '@/types/work'

const STATUS_OPTIONS = (Object.keys(TASK_STATUS_LABELS) as TaskStatus[]).map((value) => ({
  value,
  label: TASK_STATUS_LABELS[value],
}))

interface InlineStatusEditProps {
  taskId: number
  value: TaskStatus
  // Mirrors policy_caps.update_status from the server; when false the
  // cell renders as plain text (read-only). Server is authoritative —
  // every PATCH still hits TaskPolicy#update_status?.
  canUpdate: boolean
  // Called after a successful (non-rolled-back) status change. Forwarded
  // to InlineSelect — required so every caller refreshes its own state.
  onAfterChange: () => void
}

export function InlineStatusEdit({ taskId, value, canUpdate, onAfterChange }: InlineStatusEditProps) {
  return (
    <InlineSelect
      value={value}
      options={STATUS_OPTIONS}
      // Sprint 5b DR-T1-C: pass source=inline_edit symmetrically with the
      // Kanban drag handler's ?source=kanban so SC2 telemetry doesn't have
      // to rely on absence-as-signal. Allowlisted server-side; anything
      // else collapses to :inline_edit.
      endpoint={`/work/tasks/${taskId}/update_status?source=inline_edit`}
      paramKey="status"
      disabled={!canUpdate}
      ariaLabel="Statut de la tâche"
      onAfterChange={onAfterChange}
    />
  )
}
